import React, { useState, useRef, useEffect } from "react";
import {BsClock, BsEnvelope, BsFillPencilFill, BsKey, BsAsterisk,BsToggle2On, BsToggle2Off, BsBuilding, BsPlus, BsShieldPlus , BsShieldMinus, BsPerson, BsList  } from 'react-icons/bs';
import { useConfirm } from '../components/ConfirmContext';
import { differenceInDays, parseISO } from "date-fns";

export default function RowActionsCompetition({row, onEdit, onSetUser, onChangeActive }) {
      useEffect(() => {
        const handleClickOutside = (e) => {
          if (
            !buttonRef.current?.contains(e.target) &&
            !menuRef.current?.contains(e.target)
          ) {
            setOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
    const { requestConfirm } = useConfirm();
      const [open, setOpen] = useState(false);
      const menuRef = useRef(null);
      const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });
    const buttonRef = useRef(null);
    const menuHeight = 200;
    const shouldOpenUp = menuPos.y + menuHeight > window.innerHeight;
      const handleToggleMenu = () => {
        if (!open && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPos({ x: rect.right - 180, y: rect.top }); // 180 = szerokość menu
            }
            setOpen((prev) => !prev);
        };
  return (
    <>   
  
    <button
        ref={buttonRef}
        onClick={handleToggleMenu}
        className="p-2 rounded hover:bg-gray-100 transition">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 12h.01M12 12h.01M18 12h.01" />
        </svg>
      </button>    
       {open && (
        <div
        ref={menuRef}
          style={{
    position: "fixed",
    left: `${menuPos.x}px`,
    top: shouldOpenUp ? "auto" : `${menuPos.y}px`,
    bottom: shouldOpenUp
      ? `${window.innerHeight - menuPos.y}px`
      : "auto",
    zIndex: 9999,
  }}
          className="
            bg-white border border-gray-200 rounded-sm shadow-sm
            animate-fadeIn
          "
        >
             <ul className="py-1 text-gray-700 text-xs">
               <li>
                         <button
                        onClick={() => {
                        onChangeActive(row);
                              setOpen(false);
                            }
                       
                        }
                        className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
                      >
                        {row.isActive === "1" ? (
    <BsToggle2On className="text-emerald-500" size={22} />
) : (
    <BsToggle2Off className="text-red-400" size={22} />
)}
                        <span>Zmień aktywność</span>
                      </button>
                    </li>
                <li>
                      <button
                        onClick={() => {
                         onSetUser(row);
                              setOpen(false);
                            }
                       
                        }
                        className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
                      >
                        <BsPlus className="w-4 h-4" />
                        <span>Przypisz uzytkownika</span>
                      </button>
                    </li>
                      <li>
                      <button
                        onClick={() => {
                             onEdit(row);
                             setOpen(false);
                        }}
                        className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
                      >
                        <BsList className="w-4 h-4" />
                        <span>Pokaż listę użytkowników</span>
                      </button>
                    </li>
                   
             </ul>
            </div>
            )}


      
    </>
  )
}